import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NavLink } from 'react-router-dom';
import ParticlesContainer from '../dashboard/ParticlesContainer';
import { withRouter } from "react-router";

const jumbotronStyle = {
  paddingBottom: '60px',
  paddingTop: '80px',
  boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",
  position: "relative",
  zIndex: "999",
}

const insideStyle = {
  position: "relative",
  zIndex: "999009",
}

class UpgradeAccount extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div className="grey lighten-5" >

        <div className="card-panel white-text teal lighten-1" style={jumbotronStyle}>
          <ParticlesContainer>
          </ParticlesContainer>
          <div className="container white-text" style={insideStyle}>
            <h4>Upgrade account</h4>
          </div>
        </div>
        <div className="mainpage container z-depth-0 ">
          <div className="row">
            <div className="col s12 m12">
              We are really glad you enjoy our service!

            <div>
                You can create up to 3 NDAs with free account and 10 NDAs with Pro account per month.
            </div>
              <div>
                Please upgrade your account and grow your business further!
            </div>
              <div className="row"></div>
              <div className="row"></div>
              <div className="row"></div>
              <div className="center"><NavLink className="waves-effect waves-light btn white-text lighten-1 teal" to='/payment'>Upgrade Your Plan</NavLink></div>

            </div>
          </div>
        </div>
      </div >

    )
  }
}

export default withRouter(UpgradeAccount);